/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { PermissionContext } from "sections/permission-context";
import { useRBAC } from "cms/auth/hooks/use-RBAC";

const PermissionContextWrapper = (props) => {

    const { children } = props || {};
    const {
        // permission_roles,
        roles,
        permissions,
        PERMISSION,
        PERMISSIONS
    } = useRBAC();

    const permissionContext = {
        roles,
        permissions,
        PERMISSION,
        PERMISSIONS
    };

    return (
        <>
            <PermissionContext.Provider value={permissionContext}>
                {children}
            </PermissionContext.Provider>
        </>
    );
};

export { PermissionContextWrapper };
